<div>
  <h5 class="sub-title mb-3">{{ datas._title }}</h5>
  <div class="form-rows">
    <p>{{ datas._status }}</p>
    <div *ngIf="apiData.responseStatus == 'Success'">
      <div *ngIf="historyData">
        <ol>
          <li
            *ngFor="let list of historyData; let i = index"
            style="word-wrap: break-word"
          >
            {{ list.remarks }}
          </li>
        </ol>
      </div>
      <div *ngIf="!historyData" class="text-center mt-3">
        <span>No Remarks Found</span>
      </div>
    </div>
  </div>
  <div class="text-center button-hover mt-5">
    <button class="mr-2" mat-raised-button (click)="cancelReason()">
      Close
    </button>
  </div>
</div>
